import React, { useEffect, useState } from 'react'
import Select, { components, createFilter } from 'react-select'
import { createUseStyles } from 'react-jss'

import { theme as localTheme } from '../../theme'
import { relativeTimeRounding } from 'moment'

const useStyles = createUseStyles(theme => ({
  groupLabel: {
    ...theme.paragraphs.bookingSelectTextStyle,
    fontStyle: 'italic',
    color: theme.colors.brushedsteel,
  },
  locationSelect: {
    '& .select__menu': {
      zIndex: 999,
    },
    '& .select__control': {
      border: 'none',
      borderRadius: theme.borderRadius,
      minHeight: 33,

      '&.select__control--is-focussed .select__single-value': {
        opacity: 0.7,
      },
    },
    '& .select__value-container': {
      ...theme.paragraphs.bookingSelectTextStyle,
      cursor: 'pointer',
      color: theme.colors.brushedsteel,
      position: 'relative',

      '& .select__single-value': {
        color: '#424b5a',
        letterSpacing: 0,
        zIndex: 1,
      },
    },
    '& .select__indicator-separator, & .select__dropdown-indicator': {
      // padding: 6,
      display: 'none',
    },
    '& .select__dropdown-indicator svg path': {
      fill: theme.colors.blue,
    },
    '& .select__clear-indicator': {
      padding: 5,
    },
    '& .select__option': {
      ...theme.paragraphs.bookingSelectTextStyle,
      border: 'none',
      cursor: 'pointer',
      paddingLeft: 25,
    },
    '& .select__input': {
      // width: '100%',

      '& input': {
        width: 'auto!important',
        cursor: 'pointer',
      },
    },
  },
  svgContainer: {
    paddingLeft: 10,
    paddingTop: 4,
  },
}))

/* const Placeholder = props => {
  return <components.Placeholder {...props} />
} */

const colourStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: 'white',
    border: '1px solid transparent',
    fontSize: 12,
    borderRadius: 17,
    outline: 'none !important',
    boxShadow: '0 !important',
    '&:hover': {
      border: '1px solid transparent',
      outline: 'none !important',
    },
    '&:active': {
      border: '1px solid transparent',
      outline: 'none !important',
    },
  }),
  input: styles => {
    return {
      ...styles,
      // width: '100%',
      // pointerEvents: 'none',
    }
  },
  valueContainer: styles => {
    return {
      ...styles,
      position: 'relative',

      ':after': {
        content: '""',
        position: 'absolute',
        right: '10px',
        width: '20px',
        height: '14px',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      },
      '&.country-au:after': {
        backgroundImage: `url(/assets/images/flag-au.svg)`,
      },
      '&.country-ca:after': {
        backgroundImage: `url(/assets/images/flag-ca.svg)`,
      },
      '&.country-de:after': {
        backgroundImage: `url(/assets/images/flag-de.svg)`,
      },
      '&.country-es:after': {
        backgroundImage: `url(/assets/images/flag-es.svg)`,
      },
      '&.country-fr:after': {
        backgroundImage: `url(/assets/images/flag-fr.svg)`,
      },
      '&.country-gb:after': {
        backgroundImage: `url(/assets/images/flag-gb.svg)`,
      },
      '&.country-it:after': {
        backgroundImage: `url(/assets/images/flag-it.svg)`,
      },
      '&.country-nz:after': {
        backgroundImage: `url(/assets/images/flag-nz.svg)`,
      },
      '&.country-us:after': {
        backgroundImage: `url(/assets/images/flag-us.svg)`,
      },
    }
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? localTheme.colors.sunflower
        : isFocused
        ? localTheme.colors.sunflower
        : null,
      color: '#000000',
      position: 'relative',
      cursor: isDisabled ? 'not-allowed' : 'default',
      fontSize: '13px',
      letterSpacing: '0.5px',
      lineHeight: '21px',
      paddingLeft: 25,
      fontFamily: 'AvenirNextLTPro',
      fontWeight: 400,
      borderRadius: 0,
      outline: 'none !important',
      boxShadow: '0 !important',
      ':active': {
        ...styles[':active'],
        outline: 'none !important',
        backgroundColor: localTheme.colors.sunflower,
      },
      ':hover': {
        ...styles[':hover'],
        outline: 'none !important',
        backgroundColor: localTheme.colors.sunflower,
      },
      ':after': {
        content: '""',
        position: 'absolute',
        right: '10px',
        width: '20px',
        height: '14px',
        backgroundImage: `url(/assets/images/flag-${data.country}.svg)`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      },
    }
  },
}

export const LocationSelect = props => {
  const classes = useStyles()
  const [countryClass, setCountryClass] = useState('')

  useEffect(() => {
    if (props.pickupLocation.hasOwnProperty('country'))
      setCountryClass(props.pickupLocation.country)
  }, [props.pickupLocation])

  const formatGroupLabel = data => (
    <div className={classes.groupLabel}>
      <span>{data.label}</span>
    </div>
  )

  const ValueContainer = ({ children, ...props }) => {
    return (
      <React.Fragment>
        <components.ValueContainer
          {...props}
          className={countryClass ? 'country-' + countryClass : ''}
        >
          {children}
        </components.ValueContainer>
      </React.Fragment>
    )
  }

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    stringify: option => `${option.label}`,
  }

  return (
    <React.Fragment>
      <Select
        id={props.name}
        name={props.name}
        value={[props.pickupLocation]}
        onChange={props.selectHandleChange}
        // onInputChange={props.selectHandleInputChange}
        options={props.pickupOptions}
        className={classes.locationSelect}
        classNamePrefix="select"
        isDisabled={props.isDisabled}
        isLoading={props.isLoading}
        isClearable={true}
        openMenuOnFocus={false}
        openMenuOnClick={false}
        isSearchable
        closeMenuOnSelect
        components={{ ValueContainer }}
        placeholder={'Enter location'}
        formatGroupLabel={formatGroupLabel}
        styles={colourStyles}
        filterOption={createFilter(filterConfig)}
        ignoreCase
      />
    </React.Fragment>
  )
}

export default LocationSelect
